import { render } from "./ConfigurationInfo.vue?vue&type=template&id=ddbb174a&scoped=true&ts=true"
import script from "./ConfigurationInfo.vue?vue&type=script&lang=ts"
export * from "./ConfigurationInfo.vue?vue&type=script&lang=ts"

import "./ConfigurationInfo.vue?vue&type=style&index=0&id=ddbb174a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbb174a"]])

export default __exports__